import Form from "./form";
import { observable, action } from "mobx";
import { lengthAtLeast, validUrl } from "core/validation";

export default class AzureDevOpsForm extends Form {
  @observable token: string;
  @observable url: string;
  @observable showing: boolean;

  validators = {
    token: { validator: lengthAtLeast(10), message: "Invalid personal access token" },
    url: { validator: validUrl, message: "Invalid organization URL" },
  };

  @action
  setDefaults() {
    this.token = "";
    this.url = "";
    this.showing = false;
  }
}
